import { makeStyles } from '@material-ui/core';


export const gridPageStyles = makeStyles((theme) => ({
    gridPageContainer: {
        [theme.breakpoints.up('md')]: {
            display: 'grid',
            gridTemplateColumns: '2fr 1fr',
        },
        '& .grid': {
            '&-main-content': {
                gridColumn: '1 / span 1',

                paddingRight: '3rem',
                [theme.breakpoints.down('md')]: {
                    paddingRight: '2rem',
                },
                [theme.breakpoints.down('sm')]: {
                    paddingRight: '0',
                },
                '&.fw-lg': {
                    [theme.breakpoints.up('lg')]: {
                        gridColumn: ' 1 / span 2',
                        paddingRight: '0',
                    },
                },
                '&.fw-tablet': {
                    [theme.breakpoints.down('md')]: {
                        gridColumn: ' 1 / span 2',
                        paddingRight: '0',
                    },
                },
            },
            '&-sidebar': {
                gridColumn: '2 / span 1',
                gridRow: '1 / span 2',
                '& .sidebar-content': {
                    width: '100%',
                    maxWidth: '100%',
                },

            },
            '&-fw-content': {
                gridColumn: ' 1 / span 2',
            },

        },
        '& .grid-nested': {
            [theme.breakpoints.up('md')]: {
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',
            },
        },
    },



}));



